import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SignUpStoreService } from '../../authentification/services/sign-up-store/sign-up-store.service';

export const recapitulatifGuard: CanActivateFn = () => {
  const signUpStoreService = inject(SignUpStoreService);
  const router = inject(Router);

  if (signUpStoreService.isInitialState()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
